import { PinType, getPinTypeFromBusinessType } from 'utils/mapsUtils';
import { StoreType } from '@tock/shared/utils/connect';
import { consumer } from '@tock/coretypes';
import { createSelector } from 'reselect';
import { getApp } from 'selectors/appSelector';
import { lockSelector } from 'selectors/lockSelectors';

export interface BusinessMarker {
  id: number;
  location: google.maps.LatLngLiteral;
  businessName?: string;
  pinType?: PinType;
}

export interface AvailabilityMapData {
  markers: BusinessMarker[];
  focusedLocations: google.maps.LatLngLiteral[];
}

export const getAvailability = (state: StoreType) => state.availability;

const getBusinessAvailabilityResults = (state: StoreType) =>
  state.availability.result?.offeringAvailability ?? [];

/**
 * Perform existence check on our "I" protos and return markers to plot
 * on the map and lat/lng of all markers that should be in view.
 */
export const getAvailabilityMapDataSelector = createSelector(
  getBusinessAvailabilityResults,
  (results: consumer.ISearchOfferingBusiness[]): AvailabilityMapData => {
    const mapData: AvailabilityMapData = { markers: [], focusedLocations: [] };
    for (const offering of results) {
      if (
        offering.business &&
        offering.business.id &&
        offering.business.location &&
        offering.business.location.lat &&
        offering.business.location.lng
      ) {
        const location = {
          lat: offering.business.location.lat,
          lng: offering.business.location.lng,
        };

        mapData.markers.push({
          id: offering.business.id,
          location,
          businessName: offering.business.name || undefined,
          pinType: getPinTypeFromBusinessType(offering.business.businessType || undefined),
        });
        mapData.focusedLocations.push(location);
      }
    }
    return mapData;
  }
);

export const searchIsLoadingSelector = createSelector(
  getAvailability,
  lockSelector,
  getApp,
  (availability, lock, app) =>
    availability.requestInProgress || lock.requestInProgress || app.configRequestInProgress
);
